import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { updateFooterHeight } from '../modules/appstate';
import { connect } from 'react-redux';

const Footer = (props) => {
    const ref = useRef(null);

    useEffect(() => {
        props.updateFooterHeight(ref.current.clientHeight);

        return function cleanup() {
            props.updateFooterHeight(0);
        };
    });

    return (
        <Box
            ref={ref}
            sx={{
                position: 'fixed',
                padding: '10px',
                bottom: 0,
                left: 0,
                width: '100%',
                bgcolor: 'primary.light',
                boxShadow: '0px -5px 5px -1px rgba(0,0,0,0.2)',
                zIndex: 99,
            }}>
            <Grid container justifyContent="center" spacing={1}>
                {props.children}
            </Grid>
        </Box>
    );
};

const mapDispatchToProps = { updateFooterHeight };
export default connect(null, mapDispatchToProps)(Footer);
